import { NavLink, Outlet, useLocation } from "react-router-dom";
import {
  FileText, Users, Activity, Brain, FlaskConical, ShieldCheck,
  Database,
} from "lucide-react";
import { cls } from "../lib/cls";

// Onboard + Integrations moved to /integrations (with the Onboard
// sub-tab); removed from Admin Studio to drop the duplicate entries.
// Admin keeps the admin-only surfaces.
const TABS: ReadonlyArray<{ to: string; label: string; icon: JSX.Element; sub: string }> = [
  { to: "/admin/prompts",      label: "Prompts",         sub: "What the agent says to your clients",    icon: <FileText className="w-3.5 h-3.5" /> },
  { to: "/admin/optimizer",    label: "Tuning",          sub: "Make the agent sharper over time",       icon: <FlaskConical className="w-3.5 h-3.5" /> },
  { to: "/admin/memory",       label: "Memory",          sub: "What the studio has learned",            icon: <Brain className="w-3.5 h-3.5" /> },
  { to: "/admin/datasets",     label: "Sources",         sub: "Reference catalogs and imports",         icon: <Database className="w-3.5 h-3.5" /> },
  { to: "/admin/users",        label: "Users",           sub: "Studio team access",                     icon: <Users className="w-3.5 h-3.5" /> },
  { to: "/admin/system",       label: "Status",          sub: "Live health of every service",           icon: <Activity className="w-3.5 h-3.5" /> },
];

export default function Admin(): JSX.Element {
  const loc = useLocation();
  return (
    <div className="max-w-[1280px] mx-auto px-4 sm:px-8 py-10">
      <header className="mb-4">
        <div className="eyebrow inline-flex items-center gap-1.5">
          <ShieldCheck className="w-3 h-3" /> Studio admin
        </div>
        <h1 className="display-2 mt-1 text-ink-950">Run your studio.</h1>
        <p className="text-[13px] text-ink-500 mt-1 max-w-3xl">
          Onboard projects, tune what the agent says, connect the apps you already use, and keep an eye on everything in one place.
        </p>
      </header>

      <nav className="flex items-center gap-1 mb-6 border-b border-border pb-2 overflow-x-auto">
        {TABS.map((t) => {
          const active = loc.pathname === t.to || (t.to === "/admin/prompts" && loc.pathname === "/admin");
          return (
            <NavLink
              key={t.to}
              to={t.to}
              title={t.sub}
              className={cls(
                "inline-flex items-center gap-1.5 pill border text-[11.5px] whitespace-nowrap",
                active
                  ? "bg-ink-950 text-cream border-ink-950"
                  : "bg-cream-dark border-border text-ink-700 hover:border-foyr/40 hover:text-ink-950",
              )}
            >
              {t.icon} {t.label}
            </NavLink>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}
